import { render } from "./BaseModal.vue?vue&type=template&id=88b5b04e"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__